import { render, staticRenderFns } from "./Edu_seasons.vue?vue&type=template&id=23dcb438&"
import script from "./Edu_seasons.vue?vue&type=script&lang=js&"
export * from "./Edu_seasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports